import * as React from "react";

export const CustomRatioSvg = ({}) => (
    <svg viewBox="0 0 100 100">
        <path d={d} stroke="none" fill="currentColor" transform=""/>
        <path d={d} stroke="none" fill="currentColor" transform="rotate(90 50 50)"/>
        <path d={d} stroke="none" fill="currentColor" transform="rotate(180 50 50)"/>
        <path d={d} stroke="none" fill="currentColor" transform="rotate(270 50 50)"/>
    </svg>
);

const d = "M 0,0 L 32,0 L 32,10 L 10,10 L 10,32 L 0,32 Z";
